import { showNotification, showSuccess, showError, showWarning, showInfo } from './notification.js';

window.wpbuoy = window.wpbuoy || {}
window.wpbuoy.contact = window.wpbuoy.contact || {}

window.wpbuoy.contact.submit = function(e) {
  e.preventDefault()

  const form = document.getElementById('wpcf7-f6-p84-o1')
  const submit = form.querySelector('[type="submit"]')

  submit.classList.add('loading')
  submit.disabled = true
}

window.wpbuoy.contact.showErrors = function(event) {
  if (event.detail.apiResponse.status === 'validation_failed') {
    const form = document.getElementById('wpcf7-f6-p84-o1')
    const submit = form.querySelector('[type="submit"]')

    submit.classList.remove('loading')
    submit.disabled = false

    showError(event.detail.apiResponse.message)
  }
}

window.wpbuoy.contact.showSuccess = function(event) {
  if (event.detail.apiResponse.status === 'mail_sent') {
    const forms = document.querySelectorAll('.wpcf7-form')
    
    forms.forEach(form => {
      const submit = form.querySelector('[type="submit"]')
      form.reset()
      submit.classList.remove('loading')
      submit.disabled = false
    })

    showSuccess(event.detail.apiResponse.message)
  }
}

window.wpbuoy.contact.eventListeners = function() {
  const form = document.getElementById('wpcf7-f6-p84-o1')

  if (form) {
    form.addEventListener('submit', window.wpbuoy.contact.submit)
    document.addEventListener('wpcf7mailsent', window.wpbuoy.contact.showSuccess)
    document.addEventListener('wpcf7invalid', window.wpbuoy.contact.showErrors)
  }
}

window.wpbuoy.contact.initSubjectSelect = function() {
  if ( typeof jQuery === 'undefined' || ! jQuery.fn.selectWoo ) return

  jQuery( 'select[name="subject"]' ).selectWoo({
    minimumResultsForSearch: Infinity,
    width: '100%',
  })
}

window.wpbuoy.contact.eventListeners()
window.addEventListener('load', window.wpbuoy.contact.initSubjectSelect)
